import React from "react";
import Empty from "antd/es/empty";
import Descriptions from "antd/es/descriptions";
import { useIntl } from "react-intl";
import { checkRole } from "./utils";

export default function RentalInfo({ rental }) {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });
  const isAdmin = checkRole(localStorage);

  if (!rental || !rental.status) {
    return <Empty className="empty-sign" description={t("no-rental-info")} />;
  }

  const basicItems = [
    { key: "status", label: t("rental-status"), value: rental.status },
  ];

  const adminItems = [
    { key: "city", label: t("rental-city"), value: rental.city },
    { key: "bedrooms", label: t("rental-bedrooms"), value: rental.bedrooms },
    { key: "bathrooms", label: t("rental-bathrooms"), value: rental.bathrooms },
    { key: "floor", label: t("rental-floor"), value: rental.floor },
    {
      key: "surface",
      label: t("rental-surface"),
      value: rental.surface,
    },
    { key: "sleeps", label: t("rental-sleeps"), value: rental.sleeps },
    {
      key: "sleeps_max",
      label: t("rental-sleeps-max"),
      value: rental.sleeps_max,
    },
    { key: "parking", label: t("rental-parking"), value: rental.parking },
    { key: "pms_name", label: t("rental-pms-name"), value: rental.pms_name },
    { key: "brand", label: t("rental-brand"), value: rental.brand },
  ];

  const items = isAdmin
    ? [...basicItems, ...adminItems].filter(
        (item) => item.value != null && item.value !== ""
      )
    : basicItems;

  return (
    <div style={{ maxWidth: 750 }}>
      <Descriptions
        title={`${t("rental-info")} - ${rental.name}`}
        layout="horizontal"
        column={1}
        bordered
        size="small"
      >
        {items.map((item) => (
          <Descriptions.Item key={item.key} label={item.label}>
            {item.value}
          </Descriptions.Item>
        ))}
      </Descriptions>
    </div>
  );
}
